module.exports = new __parcel__URL__("card_controller.3020b7b2.png").toString();